import { useTranslation } from 'react-i18next';

import { Link } from 'react-router-dom';

export function PageNotFound(){
    const { t } = useTranslation();
    return(
        <>
            <h2>{t("page_not_found.title")}</h2>
            <button>
                <Link to="/">{t("page_not_found.back_to_home")}</Link>
            </button>
        </>
    )
}